'use strict';

var _Logger = require('./Logger');

var _Logger2 = _interopRequireDefault(_Logger);

var _LogLevel = require('./LogLevel');

var _LogLevel2 = _interopRequireDefault(_LogLevel);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var contextualLoggers = {};

var globalLogger = new _Logger2['default']({
    level: _constants.DEBUG
});

globalLogger.on('setLevel', function (level) {
    // Apply filter level to all registered contextual loggers
    Object.keys(contextualLoggers).forEach(function (key) {
        var logger = contextualLoggers[key];
        logger.setLevel(level);
    });
});

module.exports = function (name) {
    name = String(name || '');

    if (!name) {
        return globalLogger;
    }

    if (!contextualLoggers[name]) {
        contextualLoggers[name] = new _Logger2['default'](name, {
            level: globalLogger.level
        });
    }

    return contextualLoggers[name];
};

module.exports.TRACE = _constants.TRACE;
module.exports.DEBUG = _constants.DEBUG;
module.exports.INFO = _constants.INFO;
module.exports.WARN = _constants.WARN;
module.exports.ERROR = _constants.ERROR;
module.exports.OFF = _constants.OFF;

module.exports.defineLogLevel = function (name, value) {
    return new _LogLevel2['default'](name, value);
};